import React from 'react';
export var PdfFullView = function (_a) {
    var _b = _a.deviation, files = _b.files, title = _b.title, width = _a.width, height = _a.height;
    if (!files) {
        return null;
    }
    var pdfFile = files.find(function (file) { return file.type === 'pdf'; });
    if (!pdfFile) {
        return null;
    }
    return (React.createElement("object", { "aria-label": title, data: pdfFile.src, style: { width: width, height: height }, type: "application/pdf" }));
};
export default PdfFullView;
//# sourceMappingURL=Pdf.js.map